import React from 'react'

const Fundraising: React.FC = () => {
  return <div>Fundraising</div>
}

export default Fundraising
